/*
  Перечитать страницу списка, когда снаружи сообщили об изменении (21.10.2026).

  Список с серверной пагинацией (`usePagedList`) читает своё окно сам: при показе, при
  смене страницы и размера. Но данные меняет и то, что происходит вне списка, - загрузка
  файла, соседнее действие, опрос. Такой источник отдаёт «отметку» (`stamp`: строка или
  число), и список перечитывается, когда она сменилась. Первое значение - не повод:
  первое чтение хук списка уже сделал.
*/

import { useEffect, useRef } from 'react'

export default function useReloadOn(stamp, reload) {
  const shown = useRef(stamp)

  useEffect(() => {
    if (shown.current === stamp) return
    shown.current = stamp
    reload()
  }, [stamp, reload])
}
